import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { bulkedCols, taggedCols } from "./mrqFormColumns";
import { Alert, Box, Button, styled } from "@mui/material";
import { addQuotationData } from "./api";
import CommentsBtn from "./CommentsBtn";
import SendIcon from "@mui/icons-material/Send";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const MrqFormTable = ({ data }) => {
  const [input, setInput] = useState([]);
  const [alert, setAlert] = useState("");
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(true);

  useEffect(() => {
    const tableFormatData =
      data?.mrqMaterials?.map((elem) => ({
        mrqMaterialId: elem?.id,
        description: elem?.description,
        costCode: elem?.materials[0]?.costCode,
        tagNumber: elem?.materials[0]?.taggedMaterial?.tagNumber,
        materialCode: elem?.materialCode,
        quantity: elem?.quantity,
        weight: elem?.weight,
        time: elem?.time,
        cost: elem?.cost,
      })) ?? [];
    setInput(tableFormatData);
  }, [data]);

  console.log({ data });

  const handleSaveCell = (cell, value) => {
    input[cell.row.index][cell.column.id] = value;
    setInput([...input]); //re-render with new data
    setSubmitBtnDisabled(false);
  };

  const handleSubmitForm = async () => {
    const vendorData = input.map((m) => {
      return { ...m, mrqId: data.mrqId, vendorId: data.vendorId };
    });

    await addQuotationData({ vendorData })
      .then((res) => {
        console.log({ res });
        setAlert("success");
      })
      .catch((err) => {
        console.log({ err });
        setAlert("error");
      });
  };

  const cols =
    data?.mrqMaterials &&
    data?.mrqMaterials[0]?.materials[0]?.taggedMaterial?.id
      ? taggedCols
      : bulkedCols;
  return (
    <MaterialReactTable
      columns={cols}
      enableColumnActions={false}
      enableColumnFilters={false}
      enablePagination={false}
      enableSorting={false}
      enableTopToolbar={false}
      enableBottomToolbar
      // enableRowActions
      enableEditing
      editDisplayMode={"table"}
      data={input ?? []}
      muiEditTextFieldProps={({ cell }) => ({
        //onBlur is more efficient, but could use onChange instead
        onBlur: (event) => {
          handleSaveCell(cell, event.target.value);
        },
      })}
      renderBottomToolbarCustomActions={() => {
        return (
          <div style={{ width: "100%", "& > div": { p: 0 } }}>
            {alert === "" ? (
              <Box sx={{ textAlign: "right" }}>
                <CommentsBtn data={data} />
                <Button
                  variant="contained"
                  onClick={handleSubmitForm}
                  disabled={submitBtnDisabled}
                  endIcon={<SendIcon />}
                >
                  Send Quotation
                </Button>

                {/* <Button endIcon={<UploadFileIcon />}>Upload Doc</Button> */}

                <Button
                  component="label"
                  role={undefined}
                  tabIndex={-1}
                  endIcon={<UploadFileIcon />}
                  sx={{ float: "left" }}
                >
                  Upload Document
                  <VisuallyHiddenInput
                    type="file"
                    // accept=".pdf"
                    onChange={(event) => console.log(event.target.files)}
                    multiple
                  />
                </Button>
              </Box>
            ) : (
              <Alert
                severity={alert}
                sx={{ width: "100%" }}
                action={
                  <Button
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setAlert("");
                    }}
                  >
                    Edit
                  </Button>
                }
              >
                Thanks, Changes has been saved.
              </Alert>
            )}
          </div>
        );
      }}
    />
  );
};

export default MrqFormTable;
